import { tr } from '@/i18n';

/** Имя воркспейса для показа: личное пространство называется на языке интерфейса. */
export function workspaceName(ws: { name: string; personal?: boolean }): string {
  return ws.personal ? tr('Личное пространство') : ws.name;
}
